import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/hotspot/slogon_icon.png'
import _imports_1 from '@/assets/hotspot/example_icon.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-0eb6a19f")

_pushScopeId("data-v-0eb6a19f")
const _hoisted_1 = {
  key: 0,
  class: "hotspot-module-container"
}
const _hoisted_2 = {
  key: 0,
  class: "cover-wrapper"
}
const _hoisted_3 = { class: "top-wrapper" }
const _hoisted_4 = { class: "top-slogan" }
const _hoisted_5 = /*#__PURE__*/_createVNode("img", {
  class: "top-slogan-icon",
  src: _imports_0
}, null, -1)
const _hoisted_6 = { class: "top-content" }
const _hoisted_7 = { class: "content-wrapper-title" }
const _hoisted_8 = { class: "content-wrapper" }
const _hoisted_9 = { class: "right-container" }
const _hoisted_10 = { class: "right-top" }
const _hoisted_11 = { class: "right-middle" }
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "right-action" }, [
  /*#__PURE__*/_createVNode("span", null, "查看")
], -1)
const _hoisted_13 = { class: "left-container" }
const _hoisted_14 = {
  key: 1,
  class: "detail-wrapper-bg"
}
const _hoisted_15 = { class: "detail-wrapper" }
const _hoisted_16 = {
  key: 0,
  class: "detail-top-wrapper"
}
const _hoisted_17 = {
  key: 1,
  class: "top-slogan detail-top-slogan-wrapper"
}
const _hoisted_18 = /*#__PURE__*/_createVNode("img", {
  class: "top-slogan-icon",
  src: _imports_0
}, null, -1)
const _hoisted_19 = {
  key: 0,
  class: "detail-content-item-title"
}
const _hoisted_20 = {
  key: 0,
  src: _imports_1
}
const _hoisted_21 = {
  key: 1,
  class: "detail-content-item-sub-title"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_HotspotContentList = _resolveComponent("HotspotContentList")
  const _component_Back = _resolveComponent("Back")

  return (_ctx.modules)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        (!_ctx.showDetail)
          ? (_openBlock(), _createBlock("div", _hoisted_2, [
              _createVNode("div", _hoisted_3, [
                _createVNode("span", null, _toDisplayString(_ctx.modules.top.title), 1),
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.modules.top.imgs, (i, k) => {
                  return (_openBlock(), _createBlock("img", {
                    class: "top-image",
                    key: k,
                    src: i
                  }, null, 8, ["src"]))
                }), 128)),
                _createVNode("div", _hoisted_4, [
                  _hoisted_5,
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.modules.top.slogan, (i, k) => {
                    return (_openBlock(), _createBlock("p", { key: k }, _toDisplayString(i), 1))
                  }), 128))
                ]),
                _createVNode("div", _hoisted_6, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.modules.top.intro, (i, k) => {
                    return (_openBlock(), _createBlock("p", { key: k }, _toDisplayString(i), 1))
                  }), 128))
                ])
              ]),
              _createVNode("div", _hoisted_7, [
                _createVNode("span", null, _toDisplayString(_ctx.modules.listTitle), 1)
              ]),
              _createVNode("div", _hoisted_8, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.modules.list, (i, k) => {
                  return (_openBlock(), _createBlock("div", {
                    key: k,
                    class: "content-item",
                    onClick: _withModifiers(($event: any) => (_ctx.click(k)), ["stop","prevent"])
                  }, [
                    _createVNode("div", _hoisted_9, [
                      _createVNode("div", _hoisted_10, [
                        _createVNode("img", {
                          src: i.icon
                        }, null, 8, ["src"]),
                        _createVNode("span", null, _toDisplayString(i.name), 1)
                      ]),
                      _createVNode("div", _hoisted_11, [
                        _createVNode("span", null, _toDisplayString(i.desc), 1)
                      ]),
                      _hoisted_12
                    ]),
                    _createVNode("div", _hoisted_13, [
                      _createVNode("img", {
                        src: i.cover
                      }, null, 8, ["src"])
                    ])
                  ], 8, ["onClick"]))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.showDetail && _ctx.modules.list[_ctx.currentIndex].detail)
          ? (_openBlock(), _createBlock("div", _hoisted_14, [
              _createVNode("div", _hoisted_15, [
                (_ctx.modules.list[_ctx.currentIndex].detail.top.title)
                  ? (_openBlock(), _createBlock("div", _hoisted_16, [
                      _createVNode("span", null, _toDisplayString(_ctx.modules.list[_ctx.currentIndex].detail.top.title), 1)
                    ]))
                  : _createCommentVNode("", true),
                (
            _ctx.modules.list[_ctx.currentIndex].detail.top.slogan &&
            _ctx.modules.list[_ctx.currentIndex].detail.top.slogan.length > 0
          )
                  ? (_openBlock(), _createBlock("div", _hoisted_17, [
                      _hoisted_18,
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.modules.list[_ctx.currentIndex].detail.top.slogan, (i, k) => {
                        return (_openBlock(), _createBlock("p", { key: k }, _toDisplayString(i), 1))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.modules.list[_ctx.currentIndex].detail.content, (i, k) => {
                  return (_openBlock(), _createBlock("div", {
                    class: "detail-content-item",
                    key: k
                  }, [
                    (i.title)
                      ? (_openBlock(), _createBlock("div", _hoisted_19, [
                          (i.needIcon)
                            ? (_openBlock(), _createBlock("img", _hoisted_20))
                            : _createCommentVNode("", true),
                          _createVNode("span", null, _toDisplayString(i.title), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (i.subTitle)
                      ? (_openBlock(), _createBlock("p", _hoisted_21, _toDisplayString(i.subTitle), 1))
                      : _createCommentVNode("", true),
                    _createVNode(_component_HotspotContentList, {
                      list: i.list,
                      onAudiobgstop: _ctx.audiobgstop
                    }, null, 8, ["list", "onAudiobgstop"])
                  ]))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.showDetail)
          ? (_openBlock(), _createBlock(_component_Back, {
              key: 2,
              onAction: _ctx.goBack
            }, null, 8, ["onAction"]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
})